import React from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import AdminOrgList from "./AdminOrgList";
import AdminOrgDetail from "./AdminOrgDetail";

const AdminApp = () => {
  const location = useLocation();
  const onDetail = location.pathname.startsWith("/admin/orgs/");

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="bg-white border-b border-gray-200 px-4 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="text-[18px] lg:text-[20px] font-bold text-gray-900 truncate">
            Twilanswer Admin
          </div>
          {onDetail && (
            <Link
              to="/admin"
              className="text-[13px] text-[#605BFF] font-medium hover:underline shrink-0"
            >
              All orgs
            </Link>
          )}
        </div>
        <Link
          to="/dashboard"
          className="text-[13px] text-gray-600 hover:text-gray-900 shrink-0"
        >
          Back to app
        </Link>
      </header>
      <main className="pt-6 px-4 lg:px-8 pb-12 max-w-[1400px] mx-auto">
        <Routes>
          <Route index element={<AdminOrgList />} />
          <Route path="orgs/:orgId" element={<AdminOrgDetail />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminApp;
